// 무기한 라이센스는 만료일을 9999-12-31 로 발급한다(서버가 KST 그날 끝으로 저장).
export const PERPETUAL_EXPIRY_DATE = '9999-12-31'

// 무기한은 9999-12-31 뿐이다 — 2999-12-31 등 다른 먼 날짜는 실제 만료일로 표시한다.
const PERPETUAL_YEAR = 9999

const KST_OFFSET_MS = 9 * 60 * 60 * 1000

/** 저장된 만료 시각(UTC)을 KST 날짜(yyyy-MM-dd) 로 — input type="date" 초기값용 */
export const toKstDateInput = (expiresAt: string) =>
  new Date(new Date(expiresAt).getTime() + KST_OFFSET_MS).toISOString().slice(0, 10)

export const isPerpetual = (expiresAt: string) =>
  Number(toKstDateInput(expiresAt).slice(0, 4)) === PERPETUAL_YEAR

export const formatExpiry = (expiresAt: string) =>
  isPerpetual(expiresAt) ? '무기한' : new Date(expiresAt).toLocaleDateString('ko-KR')
